<button type="button" id="starRating" class="btn btn-primary" data-toggle="modal" data-target="#starRatingModel" style="display: none;">
    Rate Us
</button>

<!-- Modal -->
<div class="modal fade" id="starRatingModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" style="color: #1D2126; font-weight: 600;font-size: 14px"
                    id="exampleModalLabel" *ngIf="!showFeedbackInput && currentQuestion === 'question1'" [@rowsAnimation]>{{question1}}</h5>
                <h5 class="modal-title" style="color: #1D2126; font-weight: 600;font-size: 14px"
                    id="exampleModalLabel" *ngIf="!showFeedbackInput && currentQuestion === 'question2'" [@rowsAnimation]>{{question2}}</h5>
                <h5 class="modal-title" style="color: #1D2126; font-weight: 600;font-size: 14px"
                    id="exampleModalLabel" *ngIf="!showFeedbackInput && currentQuestion === 'question3'" [@rowsAnimation]>{{question3}}</h5>
                <h5 class="modal-title" style="color: #1D2126; font-weight: 600;font-size: 14px"
                    id="exampleModalLabel" *ngIf="showFeedbackInput" [@rowsAnimation]>Oh! Please tell me what went wrong?</h5>
                <button type="button" class="close" id="closeModel" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="d-flex justify-content-center" *ngIf="showStars" [@rowsAnimation]>
                    <img src="assets/imgs/001-star%204.png"
                         *ngFor="let light_start of stars; let i = index"
                         (click)="countStarts(i)"
                         style="margin-right: 5px;cursor: pointer;"
                    />

                    <img src="assets/imgs/001-star%205.png"
                         *ngFor="let none of starNon;  let i = index"
                         (click)="countStarts(i, 'NON')"
                         style="margin-right: 5px;cursor: pointer;" />
                </div>
                <div class="d-flex justify-content-center" *ngIf="showFeedbackInput" [@rowsAnimation]>
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Feedback</mat-label>
                        <textarea matInput placeholder="Leave a Feedback" style="resize: none;" [(ngModel)]="feedback"></textarea>
                    </mat-form-field>
                </div>
<!--                <div style="text-align: right;color: gray;">-->
<!--                    <span>{{currentStep}}/5</span>-->
<!--                </div>-->
            </div>
            <div class="modal-footer">
                <button type="button" *ngIf="!showFeedbackInput && showNextButton" [@rowsAnimation] class="btn btn-primary" style="width: 90%;height: 42px;background: #182F7C;
border-radius: 18px;border-color: #182F7C;margin-left: 15px " (click)="nextQuestion()" [disabled] = "rating == 0"

                >SUBMIT</button>
                <button type="button" *ngIf="showFeedbackInput" [@rowsAnimation] class="btn btn-primary" style="width: 90%;height: 42px;background: #182F7C;
border-radius: 18px;border-color: #182F7C;margin-left: 15px " (click)="postUserRating()" [disabled] = "!feedback"

                >SUBMIT</button>
            </div>
            <!-- <a id="submitOpenLink" href="{{ 'https://www.emiratesnbd.com/en/survey/beta-chatbot-survey?u=' + sessionId}}" target="_blank" style="display: none;"></a> -->
        </div>
    </div>
</div>
